import type { ReactNode } from 'react';

import { cn } from '@lib/utils';

interface Props {
  children: ReactNode;
  className?: string;
}

export function SectionTitle({ children, className }: Props) {
  return (
    <h2
      className={cn(
        'text-2xl font-semibold leading-8 tracking-[-0.464px] text-[#2b2e33] md:text-[36px] md:leading-[44px] md:tracking-[-0.784px] md:text-[#1d1d1f]',
        className,
      )}
    >
      {children}
    </h2>
  );
}
